import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
declare var require: any
@Injectable()
export class ExcelService {

  constructor(private datePipe: DatePipe) {

  }

  private dataFormatInabilities(data) {
    let d = [];
    data.forEach(e => {
      let a = new Array();
      a.push(e.creationDate);
      a.push(e.dateApplication);
      a.push(e.dischargeDate);
      a.push(e.employeeNum);
      a.push(e.employeeName);
      a.push(e.employeeMarkName);
      a.push(e.employeePositionId);
      a.push(e.employeeJob);
      a.push(e.employerRegister);
      a.push(e.inabilityKey);
      a.push(e.zone);
      a.push(e.employeeTownName);
      a.push(e.startDate);
      a.push(e.endDate);
      a.push(e.numberDays);
      a.push(e.periodKey);
      a.push(e.lineInsurance);
      a.push(e.typeRisk);
      a.push(e.lingeringIssuesKey);
      a.push(e.inabilityControlKey);
      a.push(e.requiresInability);
      a.push(e.comments);
      d.push(a);
    });
    return d;
  }
  private dataFormatWorkLeave(data) {
    let d = [];
    data.forEach(e => {
      let a = new Array();
      a.push(e.employeeNum);
      a.push(e.employeeName);
      a.push(e.employeeMarkName);
      a.push(e.employeeDate);
      a.push(e.positionNo);
      a.push(e.dismissalDate);
      a.push(e.paymentType);
      a.push(e.dailySalary);
      a.push(e.companyPay);
      d.push(a);
    });
    return d;
  }
  private dataFormatHolidays(data) {
    let d = [];
    data.forEach(e => {
      let a = new Array();
      a.push(e.employeeNum);
      a.push(e.employeeName);
      a.push(e.employeeCompany);
      a.push(e.initDate);
      a.push(e.finalDate);
      a.push(e.totalDays);
      a.push(e.comments);
      d.push(a);
    });
    return d;
  }
  private dataFormatRelocations(data) {
    let d = [];
    data.forEach(e => {
      let a = new Array();
      a.push(e.employeeNum);
      a.push(e.employeeName);
      a.push(e.trademark);
      a.push(e.relocationDate);
      a.push(e.generateVacancy);
      a.push(e.position);
      a.push(e.reasonName);
      a.push(e.town);
      a.push(e.companyPay);
      d.push(a);
    });
    return d;
  }
  public generateExcelInabilities(list: any) {
    //Excel Title, Header, Data
    const title = 'Reporte de incapacidades';
    const header = ["Fecha de captura",
      "Fecha de aplicación"
      , "Fecha de terminación"
      , "Clave de trabajador"
      , "Nombre completo"
      , "Marca"
      , "Clave del puesto"
      , "Puesto"
      , "Registro IMSS"
      , "Folio"
      , "Zona"
      , "Ciudad"
      , "Fecha inicial"
      , "Fecha final"
      , "Número de días"
      , "Clave del periodo"
      , "Ramo del seguro"
      , "Tipo de riesgo"
      , "Secuelas"
      , "Control de incapacidad"
      , "Requiere cubre incapacitante"
      , "Observaciones"]
    const data = this.dataFormatInabilities(list);

    //Create workbook and worksheet
    const Excel = require('exceljs');
    const workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Incapacidades');

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Arial', family: 4, size: 12, underline: 'double', bold: true }
    worksheet.addRow([]);
    let subTitleRow = worksheet.addRow(['Fecha de creación: ' + this.datePipe.transform(new Date(), 'medium')])

    worksheet.mergeCells('A1:D2');

    //Blank Row
    worksheet.addRow([]);

    //Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DEDADA' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    // worksheet.addRows(data);

    // Add Data and Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
    });

    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);

    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs.saveAs(blob, 'Incapacidades.xlsx');
    })
  }
  public generateExcelWorkLeave(list: any) {

    //Excel Title, Header, Data
    const title = 'Reporte de bajas';
    const header = ["No. Empleado"
      , "Nombre completo"
      , "Marca"
      , "Fecha alta"
      , "Posición"
      , "Fecha baja Nóminas"
      , "Forma de pago"
      , "Salario"
      , "Compaañia"]
    const data = this.dataFormatWorkLeave(list);

    //Create workbook and worksheet
    const Excel = require('exceljs');
    const workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Bajas');

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Arial', family: 4, size: 12, underline: 'double', bold: true }
    worksheet.addRow([]);
    let subTitleRow = worksheet.addRow(['Fecha de creación: ' + this.datePipe.transform(new Date(), 'medium')])

    worksheet.mergeCells('A1:D2');

    //Blank Row
    worksheet.addRow([]);

    //Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DEDADA' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    // worksheet.addRows(data);

    // Add Data and Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
    });

    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);

    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs.saveAs(blob, 'Bajas.xlsx');
    })
  }
  /**
   * generateExcelHolidays list: any   */
  public generateExcelHolidays(list: any) {
    //Excel Title, Header, Data
    const title = 'Reporte de vacaciones';
    const header = ["No. empleado"
      , "Nombre completo"
      , "Marca"
      , "Fecha inicio"
      , "Fecha fin"
      , "No. de días"
      , "Comentario empleado"]
    const data = this.dataFormatHolidays(list);

    //Create workbook and worksheet
    const Excel = require('exceljs');
    const workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Vacaciones');

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Arial', family: 4, size: 12, underline: 'double', bold: true }
    worksheet.addRow([]);
    let subTitleRow = worksheet.addRow(['Fecha de creación: ' + this.datePipe.transform(new Date(), 'medium')])

    worksheet.mergeCells('A1:D2');

    //Blank Row
    worksheet.addRow([]);

    //Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DEDADA' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    // worksheet.addRows(data);

    // Add Data and Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
    });

    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);

    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs.saveAs(blob, 'Vacaciones.xlsx');
    })
  }
  public generateCsv(data: any) {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv;charset=utf-8;' })
    saveAs.saveAs(blob, "bajas.csv");
  }
  public generateExcelRelocations(list: any) {

    //Excel Title, Header, Data
    const title = 'Reporte de reubicaciones';
    const header = ["No. Empleado"
      , "Nombre completo"
      , "Marca"
      , "Fecha reubicación"
      , "Genera vacante"
      , "Posición"
      , "Tipo reubicación"
      , "Ciudad"
      , "Compaañia"]
    const data = this.dataFormatRelocations(list);

    //Create workbook and worksheet
    const Excel = require('exceljs');
    const workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Reubicaciones');

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Arial', family: 4, size: 12, underline: 'double', bold: true }
    worksheet.addRow([]);
    let subTitleRow = worksheet.addRow(['Fecha de creación: ' + this.datePipe.transform(new Date(), 'medium')])

    worksheet.mergeCells('A1:D2');

    //Blank Row
    worksheet.addRow([]);

    //Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DEDADA' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    // worksheet.addRows(data);

    // Add Data and Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
    });

    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);

    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs.saveAs(blob, 'Reubicaciones.xlsx');
    })
  }
}
